import { render, staticRenderFns } from "./ExposePatient.vue?vue&type=template&id=cd20c3e0&scoped=true&"
import script from "./ExposePatient.vue?vue&type=script&lang=js&"
export * from "./ExposePatient.vue?vue&type=script&lang=js&"
import style0 from "./ExposePatient.vue?vue&type=style&index=0&id=cd20c3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd20c3e0",
  null
  
)

export default component.exports